import { Clock } from "lucide-react";
import { ContactButtons } from "@/components/site/ContactButtons";
import { SITE } from "@/lib/site";

const NEXT = [
  "Wir prüfen Ihre Angaben und Fotos.",
  "Wir rufen Sie an – meist innerhalb von 30 Minuten.",
  "Wir vereinbaren einen Besichtigungstermin vor Ort.",
];

export const ContactAside = ({ title = "Lieber direkt sprechen?" }) => (
  <div className="overflow-hidden rounded-2xl bg-white shadow-lift ring-1 ring-black/5" data-testid="contact-aside">
    <div className="bg-brand-yellow px-5 py-4">
      <p className="text-lg font-bold text-brand-anthracite">{title}</p>
      <p className="mt-0.5 flex items-center gap-1.5 text-sm font-semibold text-brand-anthracite/80"><Clock className="h-4 w-4" /> Mo–Fr 24 h erreichbar</p>
    </div>
    <div className="space-y-5 p-5">
      <ContactButtons prefix="aside" />
      <div>
        <p className="mb-3 text-xs font-bold uppercase tracking-wider text-brand-blue">So geht es weiter</p>
        <ol className="space-y-3">
          {NEXT.map((t, i) => (
            <li key={t} className="flex gap-3 text-[15px]">
              <span className="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-brand-mist text-sm font-bold text-brand-blue">{i + 1}</span>
              {t}
            </li>
          ))}
        </ol>
      </div>
      <p className="rounded-xl bg-brand-mist p-4 text-sm">
        <span className="font-semibold text-brand-anthracite">{SITE.name}</span><br />
        {SITE.street}, {SITE.zip} {SITE.city}
      </p>
    </div>
  </div>
);
